import { useEffect, useState } from 'react';
import { Plus, Search, User, RotateCcw } from 'lucide-react';
import { RenderTableAbsensi, fetchGetAbsensiAll, fetchDeleteAbsensiRecord } from '../../../../../controller/dashboard/Absensi';
import ConfirmModal from '../../../../../components/ConfirmModal';
import FormAbsensiModal from '../../../../../components/FormAbsensiModal';
import { Absensi } from '../../../../../model/Absensi';

export default function PersonaliaDataAbsensi() {
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // bisa default 
    const [statusFilter, setStatusFilter] = useState('all');
    const [statusLength, setStatusLength] = useState('10');
    const [showFormModal, setShowFormModal] = useState(false);
    const [statusFormModal, setStatusFormModal] = useState("none")
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [absensiData, setAbsensiData] = useState<Absensi[]>([]);
    const [selectedAbsensi, setSelectedAbsensi] = useState<Absensi | null>(null);

    const targetTanggal = '2026-07-20'; // Contoh tanggal yang ingin dicari

    const today = new Date();
    const todayYear = String(today.getFullYear());
    const todayMonth = String(today.getMonth() + 1).padStart(2, '0');
    const todayDay = String(today.getDate()).padStart(2, '0');

    const [filterYear, setFilterYear] = useState<string>(todayYear);
    const [filterMonth, setFilterMonth] = useState<string>(todayMonth);
    const [filterDay, setFilterDay] = useState<string>(todayDay);

    const getKaryawanName = (k: any) => {
        if (!k) return '';
        if (typeof k === 'string') return k;
        return k.nama || k.username || '';
    }

    const filteredAkuns = absensiData.filter(absen => {
        const tanggalAbsen = absen.tanggal ? absen.tanggal.split(' ')[0] : '';
        const [y, m, d] = tanggalAbsen.split('-');

        if (filterYear !== 'all' && y !== filterYear) return false;
        if (filterMonth !== 'all' && m !== filterMonth.padStart(2, '0')) return false;
        if (filterDay !== 'all' && d !== filterDay.padStart(2, '0')) return false;

        const name = getKaryawanName(absen.karyawan);
        // if (searchTerm && !name.toLowerCase().includes(searchTerm.toLowerCase())) return false;

        return true;
    });

    // Group filtered data by year-month so pagination stays aligned with full months
    const groupsMap: { [key: string]: Absensi[] } = {};
    filteredAkuns.forEach(a => {
        const tanggalOnly = a.tanggal ? a.tanggal.split(' ')[0] : '';
        const [y = '', m = ''] = tanggalOnly.split('-');
        const key = `${y}-${m}`;
        if (!groupsMap[key]) groupsMap[key] = [];
        groupsMap[key].push(a);
    });

    const groupKeys = Object.keys(groupsMap).sort((a,b) => b.localeCompare(a)); // newest groups first
    const groups = groupKeys.map(k => ({ key: k, rows: (groupsMap[k] || []).slice().sort((x,y)=> (y.tanggal||'').localeCompare(x.tanggal||'')) }));

    // Paginate by groups (itemsPerPage = groups per page)
    const indexOfLastGroup = currentPage * itemsPerPage;
    const indexOfFirstGroup = indexOfLastGroup - itemsPerPage;
    const currentGroups = groups.slice(indexOfFirstGroup, indexOfLastGroup);
    // Flatten rows for RenderTableAbsensi — component will still render month headers
    const currentAkuns = currentGroups.flatMap(g => g.rows);
    let totalPages = itemsPerPage > 0 ? Math.ceil(groups.length / itemsPerPage) : 0;
    const pageNumbers = totalPages > 0 ? Array.from({ length: totalPages }, (_, i) => i + 1) : [];

    const initDataKaryawan = async () => { 
        setLoading(true);
        try {
            const res = await fetchGetAbsensiAll();
            if (res.status === 200) {
                setAbsensiData(res.data); // pastikan API kirim data array karyawan
            } else {
                setAbsensiData([]);
            }
        } catch (error) {
            console.error(error);
            setAbsensiData([]);
        } finally {
            setLoading(false);
        }
    }

    const handleEditAkun = (absen: Absensi) => {
        setStatusFormModal('edit');
        setSelectedAbsensi(absen);
        setShowFormModal(true);
    };

    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [deleteCandidate, setDeleteCandidate] = useState<Absensi | null>(null);

    const handleRequestDelete = (absen: Absensi) => {
        setDeleteCandidate(absen);
        setShowDeleteConfirm(true);
    }

    const confirmDelete = async () => {
        if(!deleteCandidate) return;
        await fetchDeleteAbsensiRecord(deleteCandidate.id);
        setShowDeleteConfirm(false);
        setDeleteCandidate(null);
        initDataKaryawan();
    }

    useEffect(() => {
        initDataKaryawan();
    }, []);

    return (
        <>z
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-6">
            <div className="max-w-8xl mx-auto">
            {/* Header */}
            <div className="mb-8">
                <div className="flex items-center mb-4">
                <User className="w-8 h-8 text-blue-600 mr-3" />
                <div>
                    <h1 className="text-3xl font-bold text-gray-800">Absensi Karyawan</h1>
                </div>
                </div>
            </div>

            {/* Controls */}
            <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
                <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
                    {/* Search */}
                    <div className="relative">
                    <button onClick={() => {  }} className="flex items-center px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors">
                        Cari Nama
                    </button>
                    </div>
                    <div className="flex items-center space-x-2">
                        <select value={filterYear} onChange={(e) => { setFilterYear(e.target.value); setCurrentPage(1); }} className="px-2 py-2 border rounded">
                            <option value="all">Semua Tahun</option>
                            {(() => {
                                const years = new Set<string>();
                                absensiData.forEach(a => { const y = a.tanggal ? a.tanggal.split(' ')[0].split('-')[0] : ''; if (y) years.add(y); });
                                years.add(todayYear);
                                return Array.from(years).filter(Boolean).sort((a,b)=>b.localeCompare(a)).map((y) => (
                                    <option key={y} value={y}>{y}</option>
                                ));
                            })()}
                        </select>
                        <select value={filterMonth} onChange={(e) => { setFilterMonth(e.target.value); setCurrentPage(1); }} className="px-2 py-2 border rounded">
                            <option value="all">Semua Bulan</option>
                            {Array.from({length:12}, (_,i) => ({v: String(i+1).padStart(2,'0'), label: new Date(0, i).toLocaleString('id-ID', { month: 'long' })})).map(m => (
                                <option key={m.v} value={m.v}>{m.label}</option>
                            ))}
                        </select>
                        <select value={filterDay} onChange={(e) => { setFilterDay(e.target.value); setCurrentPage(1); }} className="px-2 py-2 border rounded">
                            <option value="all">Semua Tanggal</option>
                            {Array.from({length:31}, (_,i) => String(i+1).padStart(2,'0')).map(d => (
                                <option key={d} value={d}>{d}</option>
                            ))}
                        </select>
                    </div>

                </div>

                <div className="flex space-x-3">
                    <button 
                        onClick={initDataKaryawan}
                        disabled={loading}
                        className="flex items-center px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors">
                        <RotateCcw className={`w-4 h-4 mr-2 ${loading ? "animate-spin" : ""}`} />
                        {loading ? "Memuat..." : "Muat Ulang"}
                    </button>
                    <button
                        onClick={() => { setFilterYear(todayYear); setFilterMonth(todayMonth); setFilterDay(todayDay); setCurrentPage(1); }}
                        className="flex items-center px-4 py-2 text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
                        Reset Filter
                    </button>
                </div>
                </div>
            </div>

            {/* Employee Table */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                    <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Karyawan
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Jam Absen
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Aktivitas
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Aksi
                        </th>
                    </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {
                        loading? 
                        <>
                            <tr>
                            <td colSpan={6} className="text-center py-4 text-gray-500">
                                Sedang Loading . . .
                            </td>
                            </tr>
                        </>
                        :
                        <>
                            <RenderTableAbsensi data={currentAkuns} onOpenEdit={handleEditAkun} onRequestDelete={handleRequestDelete} onRemoveState={initDataKaryawan}/>
                            { showFormModal && <FormAbsensiModal absensiDetail={selectedAbsensi} setShowFormModal={setShowFormModal} onPostState={initDataKaryawan} /> }
                            { showDeleteConfirm && <ConfirmModal title="Hapus Absensi" onConfirm={confirmDelete} onCancel={() => setShowDeleteConfirm(false)}>Apakah Anda yakin ingin menghapus absensi {deleteCandidate ? `${deleteCandidate.karyawan.nama} - ${deleteCandidate.tanggal}` : ''}?</ConfirmModal> }
                        </>
                        }
                    </tbody>
                </table>
                </div>
            </div>

            {/* Pagination */}
            <div className="mt-6 flex items-center justify-between">
                <div className="text-sm text-gray-700">
                Menampilkan <span className="font-medium">{currentPage}</span> hingga{' '}
                <span className="font-medium">{statusLength === "all" ? absensiData.length : statusLength}</span> dari{' '}
                <span className="font-medium">{absensiData.length}</span> karyawan
                </div>
                <div className="flex space-x-2">
                <button 
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(prev => prev - 1)}
                className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
                    Previous
                </button>
                
                { pageNumbers.map((page) =>( 
                    <button 
                    key={page}
                    onClick={() => setCurrentPage(page)}
                    className={`px-3 py-1 rounded ${ currentPage === page ? "bg-blue-500 text-white" : "bg-gray-200" }`}>
                    {page}
                    </button>
                ))}
                
                <button 
                    disabled={currentPage === Math.ceil(filteredAkuns.length / itemsPerPage)}
                    onClick={() => setCurrentPage(prev => prev + 1)}
                    className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
                    Next
                </button>
                </div>
            </div>
            </div>

            {/* Add Employee Modal */}
            {/* {showFormModal && <FormAkunModal absensiDetail={selectedAbsensi} statusForm={statusFormModal} setShowFormModal={setShowFormModal} onPostState={initDataKaryawan}/>} */}

        </div>
        </>
    )
}
